import { render, staticRenderFns } from "./dev_icheck.vue?vue&type=template&id=a8842dea&"
import script from "./dev_icheck.vue?vue&type=script&lang=js&"
export * from "./dev_icheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports